import { useQuery } from '@tanstack/react-query'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { venuesQueryOptions } from '@/features/venues/api'
import { VenuesPage } from '@/features/venues/pages/venues-page'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/venues/')({
  loader: async ({ context, params }) => {
    const { venues } = await context.queryClient.ensureQueryData(
      venuesQueryOptions(params.workspaceSlug),
    )
    const firstVenue = venues[0]
    if (firstVenue) {
      throw redirect({
        to: '/w/$workspaceSlug/venues/$venueId',
        params: { workspaceSlug: params.workspaceSlug, venueId: firstVenue.venue.id },
        search: true,
        replace: true,
      })
    }
  },
  component: VenuesRoute,
})

function VenuesRoute() {
  const { workspaceSlug } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return <VenuesPage workspaceSlug={workspaceSlug} canWrite={workspace.data?.role !== 'viewer'} />
}
